import { type ProviderOffer } from "../../../../types/dtos/api/sales/provider-offer.dto";
import { type OfferPricingProviderPlugin } from "./OfferPricingProvider.contract";
import { blablacarOfferPricingProviderPlugin } from "./providers/blablacar.OfferPricingProvider";
import { blabladailyOfferPricingProviderPlugin } from "./providers/blabladaily.OfferPricingProvider";
import { completionStrategyOfferPricingProviderPlugin } from "./providers/completion_strategy.OfferPricingProvider";
import { rentalMotisOfferPricingProviderPlugin } from "./providers/rental_motis.OfferPricingProvider";
import { swissCffOfferPricingProviderPlugin } from "./providers/swiss_cff.OfferPricingProvider";
import { unknownOfferPricingProviderPlugin } from "./providers/unknown.OfferPricingProvider";

const providerPlugins: Record<ProviderOffer["provider"], OfferPricingProviderPlugin> = {
    "swiss_cff":           swissCffOfferPricingProviderPlugin,
    "blablacar":           blablacarOfferPricingProviderPlugin,
    "blabladaily":         blabladailyOfferPricingProviderPlugin,
    "rental_motis":        rentalMotisOfferPricingProviderPlugin,
    "completion_strategy": completionStrategyOfferPricingProviderPlugin,
    "unknown":             unknownOfferPricingProviderPlugin,
};

/**
 * Returns the plugin registered for a provider discriminant key.
 *
 * @param providerKey Provider discriminant from offer payload.
 * @returns Matching provider plugin instance.
 */
export const getOfferPricingProviderPlugin = ( providerKey: ProviderOffer["provider"] ): OfferPricingProviderPlugin => {
    return providerPlugins[providerKey];
};

/**
 * Lists all provider plugins in registry order.
 *
 * @returns Ordered list of provider plugins.
 */
export const getAllOfferPricingProviderPlugins = (): OfferPricingProviderPlugin[] => {
    return Object.values( providerPlugins );
};
